import { render, staticRenderFns } from "./ShippingIntegrationTable.vue?vue&type=template&id=43134b0c"
import script from "./ShippingIntegrationTable.vue?vue&type=script&lang=js"
export * from "./ShippingIntegrationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports